'use strict';

import React from 'react';
import { useState, useRef } from 'react';

import { Button, Form, Stack, Row, Col } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Alert from '../helper/Alert';
import Password from './Password';

import { code } from '../helper/Schema';

// schema for form validation
const schema = yup.object().shape({
    email: yup.string().required("Bitte eine E-Mail-Adresse oder Username eingeben"),
    password: yup.string().required("Bitte ein Password eingeben.")
});

const schema2 = yup.object().shape({
    code: code
});

function Login() {
    const [permanent, setPermanent] = useState(false);
    const [message, setMessage] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [showPasswordReset, setShowPasswordReset] = useState(false);
    const [passwordShown, setPasswordShown] = useState(false);
    const [showCode, setShowCode] = useState(false);
    const [loginValues, setLoginValues] = useState({});

    const formRef = useRef(null);
    const formRef2 = useRef(null);

    const { request } = useRequest();

    const login = async (values) => {        
        values.permanent = permanent;
        setMessage(false);
        setLoginValues(loginValues);
        try {
            setDisabled(true);
            let result = await request('/Login/Login', values);
            let json = result.data;
            setDisabled(false);
            if (json.r == 1) {
                let url = new URL(window.location.href);

                //wenn ReturnUrl im GET steht, wird auf returnUrl redirected, sonst wird auf die Übersicht basierend auf User-Rolle
                if (url.searchParams.has("ReturnUrl")) {
                    let redirect = decodeURIComponent(url.searchParams.get("ReturnUrl"));
                    url.searchParams.delete("ReturnUrl");
                    history.replaceState(history.state, "", url.href);
                    location.pathname = redirect;
                }
                else if (json.status == 1 && json.user.Role == "School") {
                    location.pathname = "/School";
                }
                else if (json.status == 1 && json.user.Role == "Business") {
                    location.pathname = "/Business";
                }
                else if (json.status == 1 && json.user.Role == "Operator") {
                    location.pathname = "/Operator/Dashboard";
                }
                else if (json.Status == 1) {
                    toast.error("Fehler");
                    location.pathname = "/Home/Privacy";
                }
                else {
                    location.pathname = "/ReturnUrl";
                }
            }
            else {
                if (json.secret) {
                    setShowCode(true);
                    formRef.current.setFieldValue("code", "");
                }
                else {
                    setMessage(json.message);

                    if (values.code) {
                        setShowCode(false);
                        setLoginValues({});
                        formRef2.current.setFieldValue("code", "");  
                    }
                }
                
            }
        }
        catch (ex) {
            setDisabled(false);
            toast.error(ex);
            return;
        }
    }

    

    if (showPasswordReset) return <Password setShowPasswordReset={setShowPasswordReset} />;

    if (showCode) {
        
        return (
            <Formik
                innerRef={(f) => (formRef2.current = f)}
                validationSchema={schema2}
                onSubmit={(values) => {
                    login({ ...loginValues, ...values });
                }}
                initialValues={{
                    code: '',
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => (
                    <>
                        <h1>Zwei-Faktor</h1>
                        <Form id="login-form" noValidate onSubmit={handleSubmit}>
                            <Stack gap={2} className="">
                                {message && <Alert type="error" message={message} />}
                                <Form.Group className="mb-3" controlId="code">
                                    <Form.Control disabled={disabled} isInvalid={errors.code && touched.code} type="text" placeholder="Zwei-Faktor Code" name="code" value={values.code} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.code}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Button id="login-btn" className="btn-block" disabled={disabled} variant="secondary" type="submit">
                                    {!disabled && <i className="fa-solid fa-right-to-bracket mr-2"></i>}
                                    {disabled && <i className="fa-solid fa-spinner fa-spin-pulse mr-2"></i>}
                                    Anmelden
                                </Button>
                            </Stack>
                        </Form>
                    </>
                )}
            </Formik>

        );
    } 


    return (
        <Formik
            innerRef={(f) => (formRef.current = f)}
            validationSchema={schema}
            onSubmit={(values) => {
                login(values);
            }}
            initialValues={{
                email: '',
                password: ''
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => (
                <>
                    <h1>Login</h1>
                    <Form id="login-form" noValidate onSubmit={handleSubmit}>
                        <Stack gap={2} className="">
                            {message && <Alert type="error" message={message} />}
                            <Form.Group className="mb-3" controlId="email">
                                <Form.Control disabled={disabled} isInvalid={errors.email && touched.email} type="email" placeholder="E-Mail-Adresse oder Username" name="email" value={values.email} onBlur={handleBlur} onChange={handleChange} />
                                <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="password" autoComplete="off">
                                <Form.Control disabled={disabled} isInvalid={errors.password && touched.password} type={passwordShown ? "text" : "password"} placeholder="Passwort" name="password" value={values.password} onBlur={handleBlur} onChange={handleChange} />
                                <Form.Control.Feedback type="invalid">
                                    {errors.password}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Row id="login-options">
                                <Col>
                                    <Form.Group className="mb-3 text-left" controlId="permanent">
                                        <Form.Check disabled={disabled} type="checkbox" label="Angemeldet bleiben" name="permanent" checked={permanent} onChange={(e) => setPermanent(e.target.checked)} />
                                    </Form.Group>
                                </Col>
                                <Col className="text-right">
                                    <button type="button" onClick={(e) => setShowPasswordReset(true) } className="btn btn-link text-light text-right p-0">Passwort vergessen</button>
                                </Col>
                            </Row>
                        
                            <Button id="login-btn" className="btn-block" disabled={disabled} variant="secondary" type="submit">
                                {!disabled && <i className="fa-solid fa-right-to-bracket mr-2"></i>}
                                {disabled && <i className="fa-solid fa-spinner fa-spin-pulse mr-2"></i>}
                                Anmelden
                            </Button>
                        </Stack>
                    </Form>
                </>
            )}
        </Formik>
    );
}

export default Login;